export const toBool = value =>{
    if(value === "true") return true
    else return false
}